import { Capacitor, registerPlugin } from '@capacitor/core';
import { api } from './api';

// Native always-on background service (see android TrackerService). Older APKs lack it.
const Tracker = registerPlugin('SahakarTracker');
const DEVICE_KEY = 'sahakar_native_device_id';
const OWNER_KEY = 'sahakar_native_tracker_user';
const BASE = process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '');

export const hasNativeTracker = () => Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('SahakarTracker');

const deviceId = () => {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
};

export const trackerStatus = () => Tracker.getStatus();
export const askLocation = () => Tracker.askLocation();
export const askBackground = () => Tracker.askBackground();
export const askNotifications = () => Tracker.askNotifications();
export const askBatteryExemption = () => Tracker.askBatteryExemption();
export const openAppSettings = () => Tracker.openAppSettings();

// Registers this phone for the signed-in user (once) and starts the service.
export async function ensureNativeTracker(userId) {
  const st = await Tracker.getStatus();
  if (st.configured && localStorage.getItem(OWNER_KEY) === userId) return st;
  const { data } = await api.post('/device/register', { device_id: deviceId(), platform: 'android' });
  const res = await Tracker.start({ baseUrl: BASE, appUrl: window.location.origin, token: data.device_token, track: data.track });
  localStorage.setItem(OWNER_KEY, userId);
  return res;
}

export async function stopNativeTracker() {
  if (!hasNativeTracker()) return;
  try { await api.post('/device/revoke', { device_id: deviceId(), platform: 'android' }); } catch { /* signing out anyway */ }
  try { await Tracker.stop(); } catch { /* noop */ }
  localStorage.removeItem(OWNER_KEY);
}
